import type { UserLoginStatus } from './pageViewTrackingEventSchema';
import defaultCountryCode from '@spa/lib/configs/defaultCountryCode';
import defaultLocale from '@spa/lib/configs/defaultLocale';

export const resolvePageLanguage = (): string => (defaultLocale.split('-')[0] ?? '').toLowerCase();

export const resolvePageCountry = (): string => defaultCountryCode.toUpperCase();

export const resolveUserLoginStatus = (authenticatedUserId: string | null): UserLoginStatus =>
  authenticatedUserId !== null ? 'logged_in' : 'guest';
